import ContinuePage from "@components/ContinuePage"

export default function LooksmaxxingDoingAmazingPage() {
  return <ContinuePage emoji="🎯" translationKey="doingAmazingLooksmaxxing" />
}
